var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLiberty2X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.45087 17.5654L2.72546 22.287H21.2746L18.5492 17.5654H5.45087Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.22161L9.27459 1.5L0 17.5653H5.45082L12 6.22161Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5492 17.5653H24L14.7254 1.5L12 6.22161L18.5492 17.5653Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.7541C13.6298 16.7541 14.951 15.4329 14.951 13.8031C14.951 12.1733 13.6298 10.8521 12 10.8521C10.3702 10.8521 9.04895 12.1733 9.04895 13.8031C9.04895 15.4329 10.3702 16.7541 12 16.7541Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiberty2X);
export default __webpack_public_path__ + "static/media/liberty-2-x.4771f46a46d0f196d2c6819cc2aa5ceb.svg";
export { ForwardRef as ReactComponent };